exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".chart,.chart-wrap{position:relative}.chart{z-index:2;padding:1.5rem;background:#484a4e;background:linear-gradient(180deg,#333338 0,#222228)}.chart canvas{height:auto!important;max-width:100%}.chart--pdf{position:absolute;top:0;left:0;right:0;bottom:0;z-index:1;opacity:0}.chart--pie{padding-top:3rem}.chart--pie .chartLegend,.chart--pie canvas{margin-left:auto;margin-right:auto}.chart--pie .chartLegend{max-width:400px}.chartLegend{list-style-type:none;padding:0;text-align:center;font-size:.75rem;margin-top:1.5rem}.chartLegend__item{display:inline-block;margin-right:.8rem;margin-bottom:.5rem;color:#ddd}.chartLegend__color{display:inline-block;width:1em;height:1em;background:#ddd;margin-right:.5em;transform:translate3d(0,2px,0)}.chart-slider{overflow:hidden}.chart-slider__wrapper{width:200%;display:flex;transform:translateZ(0)}.chart-slider__chart{width:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-c4c5995c!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Chart.vue
// module id = 282
// module chunks = 0